import React, {useMemo} from "react";
import {JsonForms} from "@jsonforms/react";
import {Box, ThemeProvider} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {validationMode} from "./constants";
import {languageSelector} from "../../state/app/appSelectors";
import {getRenderers, jsonformsThemeCustomization} from "./utils";

const CustomJsonForms = ({
  schema,
  uischema,
  data,
  setData,
  setErrors,
  showValidation = true,
  i18nPrefix,
  fileHandlerUploadUrl,
  fileHandlerDownload
}) => {
  const {t, i18n} = useTranslation();
  const lang = useSelector(languageSelector);

  const translation = useMemo(
    () => (key, defaultMessage, context) => {
      const errorParam = context?.error?.params ? Object.values(context.error.params)[0] : null;
      if (key === "error.minLength" && errorParam === 1) {
        return t("components.customJsonForms.error.notEmptyString");
      } else if (key === "error.minItems" && errorParam === 1) {
        return t("components.customJsonForms.error.notEmptyList");
      } else if (key === "error.uniqueItems") {
        return t("components.customJsonForms.error.noDuplicateItems");
      } else if (i18nPrefix && i18n.exists(`${i18nPrefix}.${key}`)) {
        return t(`${i18nPrefix}.${key}`, {param: errorParam});
      } else if (i18n.exists(`components.customJsonForms.${key}`)) {
        return t(`components.customJsonForms.${key}`, {param: errorParam});
      } else {
        return defaultMessage;
      }
    },
    [t, i18n, i18nPrefix]
  );

  const renderers = useMemo(() => getRenderers(showValidation), [showValidation]);

  return (
    <Box className="custom-json-forms__wrapper" sx={{width: "100%"}}>
      <ThemeProvider theme={jsonformsThemeCustomization}>
        <JsonForms
          schema={schema}
          uischema={uischema}
          renderers={renderers}
          data={data}
          onChange={({data, errors}) => {
            if (setData) setData(data);
            if (setErrors) setErrors([...errors]);
          }}
          i18n={{locale: lang, translate: translation}}
          validationMode={showValidation ? validationMode.show : validationMode.hide}
          config={{
            fileHandler: {
              fileUploadUrl: fileHandlerUploadUrl,
              onFileDownload: fileHandlerDownload
            }
          }}
        />
      </ThemeProvider>
    </Box>
  );
};

export default CustomJsonForms;
